<!--<div class="card card-custom" style="max-height: 80vh">-->

<div class="card-header" style="padding-bottom: 0px">
  <div class="card-title">
    <h3 class="card-label">{{ 'Patient Ranges ' }}</h3>
  </div>
</div>
<mat-dialog-content
  class="navi-hover scroll card-body"
  [perfectScrollbar]="{ wheelPropagation: false }"
>
  <div style="padding: 20px 5px">
    <div class="example-container">
      <mat-formio
        [form]="inventoryForm"
        #formio
        (change)="onChange($event)"
        [submission]="model"
      ></mat-formio>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 18px 36px">
  <div style="width: 100%; display: flex; justify-content: flex-end">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
          (click)="onCancelClick()"
          [disabled]="disableBtns"
        >
          Cancel</button
        >&nbsp;
        <button
          type="submit"
          mat-raised-button
          color="primary"
          matTooltip="Create"
          style="margin-right: 5px"
          [disabled]="disableBtns || disableSaveBtns"
          (click)="onSubmit()"
        >
          {{ 'Save' }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
<!--</div>-->
